<template>
  <v-container class="pa-0 ma-0">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" sm="12">
          <v-select
            outlined
            label="Lieu de travail / d'étude principal *"
            dense
            :items="sites"
            v-model="park.site"
          ></v-select>
          <v-select
            outlined
            dense
            block
            label="Année académique"
            :items="years"
            v-model="park.year"
            class="mt-10"
          ></v-select>
          <v-autocomplete
            v-model="requester"
            :items="carpoolers"
            :search-input.sync="searchCarpoolers"
            label="Demandeur"
            outlined
            @input="clearSearchCarpoolers"
            no-data-text="Tapez le nom d'une personne..."
            dense
          >
          </v-autocomplete>
          <v-text-field
            outlined
            label="Prénom *"
            v-model="park.firstname"
            dense
            required
          />
          <v-text-field
            outlined
            label="Nom *"
            v-model="park.lastname"
            dense
            required
          />
          <v-text-field
            outlined
            label="E-mail *"
            v-model="park.email"
            dense
            required
          />
          <v-select
            outlined
            label="Type *"
            dense
            :items="types"
            v-model="park.type"
          ></v-select>

          <v-select
            outlined
            label="Type d'études *"
            dense
            :items="studyTypes"
            v-model="park.studyType"
            v-if="park.type === 'Étudiant'"
          ></v-select>
          <v-radio-group
            v-model="park.unityType"
            row
            v-if="['Collaborateur', 'Apprenti'].indexOf(park.type) > -1"
          >
            <v-radio
              label="Département"
              color="primary"
              value="departments"
            ></v-radio>
            <v-radio label="Centre" color="primary" value="centers"></v-radio>
            <v-radio label="Service" color="primary" value="services"></v-radio>
            <v-radio
              label="Support transversal"
              color="primary"
              value="transversals"
            ></v-radio>
            <v-radio
              label="Direction et état-major de la Direction"
              color="primary"
              value="direction"
            ></v-radio>
            <v-radio label="Autre" color="primary" value="others"></v-radio>
          </v-radio-group>
          <v-select
            dense
            outlined
            :label="unities.labels[park.unityType]"
            v-model="park.unity"
            :items="unities[park.unityType]"
          ></v-select>
          <div class="subtitle-2">Adresse de domicile durant la semaine</div>
          <v-autocomplete
            outlined
            dense
            label="Adresse *"
            v-model="park.address"
            :items="addresses"
            :search-input.sync="searchAddresses"
            :loading="loadingAddresses"
            :filter="customFilter"
            v-if="addressType === 'local'"
            required
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>Recherchez une adresse...</v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <div v-html="item.text"></div>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-html="item.text"></v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-textarea
            label="Adresse *"
            outlined
            dense
            v-if="addressType === 'aborad'"
            v-model="park.address.label"
            required
          ></v-textarea>
          <v-text-field
            outlined
            label="Immatriculation du véhicule *"
            v-model="park.registration"
            dense
            required
          />
          <v-divider></v-divider>
          <div class="my-10">
            <div class="mt-5">
              <div class="subtitle-2">Enfants à charge</div>
              <div class="body-2">
                J'ai au moins un enfant à charge de moins de 12 ans et certifie
                avoir besoin de mon véhicule au moins 3 fois par semaine depuis
                mon lieu de travail pour son ou ses besoins.
              </div>
            </div>
            <v-item-group
              active-class="grey lighten-2"
              v-model="park.children"
              class="mb-5"
              mandatory
            >
              <v-row>
                <v-col sm="2" class="pr-0">
                  <v-item v-slot:default="{ toggle }" :value="false">
                    <v-card
                      class="d-flex align-center rounded-l-xl rounded-r-0"
                      :rounded="false"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Non</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
                <v-col sm="2" class="pl-0">
                  <v-item v-slot:default="{ toggle }" :value="true">
                    <v-card
                      class="d-flex align-center rounded-r-xl rounded-l-0"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Oui</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
            <v-textarea
              outlined
              dense
              v-model="park.childrenReason"
              label="Explications complémentaires *"
              placeholder="Merci d'expliquer ici votre situation concernant le besoin d'un macaron pour enfants à charge"
              v-if="park.children"
              required
            ></v-textarea>
          </div>

          <v-divider></v-divider>

          <div class="my-10" v-if="park.type !== 'Étudiant'">
            <div class="mt-5">
              <div class="subtitle-2">
                Déplacements professionnels fréquents
              </div>
              <div class="body-2">
                J'ai besoin d'un véhicule privé pour des déplacements
                professionnels au moins 3 fois par semaine
              </div>
            </div>
            <v-item-group
              active-class="grey lighten-2"
              v-model="park.corporate"
              class="mb-5"
              mandatory
            >
              <v-row>
                <v-col sm="2" class="pr-0">
                  <v-item v-slot:default="{ toggle }" :value="false">
                    <v-card
                      class="d-flex align-center rounded-l-xl rounded-r-0"
                      :rounded="false"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Non</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
                <v-col sm="2" class="pl-0">
                  <v-item v-slot:default="{ toggle }" :value="true">
                    <v-card
                      class="d-flex align-center rounded-r-xl rounded-l-0"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Oui</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
            <v-textarea
              outlined
              dense
              v-model="park.corporateReason"
              label="Explications complémentaires *"
              placeholder="Merci d'expliquer ici votre situation concernant le besoin d'un macaron pour des déplacements professionnels"
              v-if="park.corporate"
              required
            ></v-textarea>
            <div class="caption mb-10" v-if="park.corporate">
              Remarque : Le besoin d'un véhicule pour des déplacements
              professionnels au moins trois fois par semaine pourra être vérifié
              auprès du supérieur hiérarchique. Pour des déplacements moins
              fréquents, l'utilisation d'un véhicule HEIG-VD ou l'achat de
              tickets de stationnement sont recommandés
            </div>
          </div>

          <v-divider v-if="park.type !== 'Étudiant'"></v-divider>

          <div class="my-10">
            <div class="mt-5">
              <div class="subtitle-2">
                Raisons médicales (<a
                  href="/batiments/parking/Documents/app/attestation-a-remplir-par-le-medecin.pdf"
                  class="body-2"
                  target="_blank"
                  >attestation à remplir par le médecin</a
                >)
              </div>
              <div class="body-2">
                Je ne peux me déplacer autrement qu'en voiture pour des raisons
                de santé, ou j'ai besoin d'un véhicule pour me rendre à des
                examens médicaux fréquents
              </div>
            </div>
            <v-item-group
              active-class="grey lighten-2"
              v-model="park.health"
              class="mb-5"
              mandatory
            >
              <v-row>
                <v-col sm="2" class="pr-0">
                  <v-item v-slot:default="{ toggle }" :value="false">
                    <v-card
                      class="d-flex align-center rounded-l-xl rounded-r-0"
                      :rounded="false"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Non</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
                <v-col sm="2" class="pl-0">
                  <v-item v-slot:default="{ toggle }" :value="true">
                    <v-card
                      class="d-flex align-center rounded-r-xl rounded-l-0"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Oui</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
            <v-file-input
              dense
              outlined
              accept=".pdf"
              label="Attestation du médecin *"
              @change="handleUpload"
              @click:clear="removeDocument"
              :loading="uploading"
              hint="Fichiers au format PDF"
              :persistent-hint="true"
              v-if="park.health"
              required
            ></v-file-input>
          </div>

          <v-divider></v-divider>

          <div class="my-10">
            <div class="mt-5">
              <div class="subtitle-2">Covoiturage</div>
            </div>
            <v-item-group
              active-class="grey lighten-2"
              v-model="park.carpool"
              class="mb-5"
              mandatory
            >
              <v-row>
                <v-col sm="2" class="pr-0">
                  <v-item v-slot:default="{ toggle }" :value="false">
                    <v-card
                      class="d-flex align-center rounded-l-xl rounded-r-0"
                      :rounded="false"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Non</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
                <v-col sm="2" class="pl-0">
                  <v-item v-slot:default="{ toggle }" :value="true">
                    <v-card
                      class="d-flex align-center rounded-r-xl rounded-l-0"
                      height="40"
                      @click="toggle"
                      outlined
                    >
                      <v-scroll-y-transition>
                        <div class="flex-grow-1 text-center">Oui</div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
            <v-autocomplete
              v-model="park.carpoolers"
              :items="carpoolers"
              :search-input.sync="searchCarpoolers"
              label="Personnes qui patageront le trajet *"
              outlined
              multiple
              @input="clearSearchCarpoolers"
              no-data-text="Tapez le nom d'une personne..."
              v-if="park.carpool"
              counter="4"
              :rules="[
                (value) => {
                  return this.park.carpoolers.length > 4
                    ? 'Le nombre de covoitureur est limité à 4'
                    : true;
                },
              ]"
              required
            >
              <template v-slot:selection="data">
                <v-chip
                  small
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(data.item)"
                  >{{ data.item.text }}</v-chip
                >
              </template>
            </v-autocomplete>
            <div v-if="park.carpool" class="body-2">
              La ou les personnes qui partageront le trajet recevront un email
              de vérification leur demandant de préciser leur adresse de
              domicile. La faisabilité du trajet en covoiturage pourra être
              vérifiée
            </div>
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-row>
        <v-col cols="12" sm="12" class="mb-10">
          <v-checkbox v-model="park.acceptedPolicies" disabled>
            <template v-slot:label>
              <div>
                Le demandeur a pris connaissance de la
                <a
                  target="_blank"
                  href="https://intra.heig-vd.ch/batiments/mobilite/Documents/app/directive-relative-au-stationnement-sur-le-site-de-cheseaux.pdf"
                  @click.stop
                  >directive HEIG-VD relative au stationnement sur le site de
                  Cheseaux</a
                >.
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="park.acceptedDataPolicies" disabled>
            <template v-slot:label>
              <div>
                Le demandeur reconnait que, par l’envoi de sa demande, les
                membres du Groupe de travail Mobilité ont accès à l’ensemble des
                données communiquées.
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="park.acceptedDataAccuracy" disabled>
            <template v-slot:label>
              <div>
                Le demandeur certifie que les données communiquées sont exactes.
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="8">
          <validation :park="park" :requiredFields="requiredFields" />
        </v-col>
        <v-col class="text-end">
          <v-btn
            text
            @click="submitForm"
            :disabled="!(this.requiredFields && this.valid)"
            :loading="submitting"
            outlined
            >Soumettre la demande</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import Validation from "@/components/Validation";

export default {
  name: "Park",
  props: [
    "closeFormDialog",
    "updateRequests",
    "formDialog",
    "openSnackbar",
    "years",
  ],
  components: {
    Validation,
  },
  data: () => ({
    sites: ["Cheseaux", "St-Roch", "Y-Parc"],
    requester: {},
    addressType: "local",
    unities: {
      labels: {
        departments: "Département *",
        centers: "Centre *",
        services: "Service *",
        transversals: "Support transversal *",
        direction: "Direction et état-major de Direction *",
        others: "Autre *",
      },
      departments: ["COMEM+", "EC+G", "HEG", "TIC", "TIN"],
      centers: [
        "Formation continue",
        "Formation de base",
        "Ra&D, innovation et transfert de technologie",
        "Relations Internationales",
      ],
      services: [
        "Communication & vie du campus",
        "Finances",
        "Infrastructures & bâtiments",
        "Ressources humaines",
        "Informatique & systèmes d'information",
      ],
      transversals: ["Innovation", "SIPA", "Secrétariat académique"],
      direction: ["Direction", "Etat-major de la Direction"],
      others: ["Concierge", "Restaurant"],
    },
    park: {
      idisa: "no-idisa",
      firstname: "",
      lastname: "",
      email: "",
      type: "",
      studyType: "",
      unityType: "departments",
      address: {},
      children: false,
      childrenReason: "",
      corporate: false,
      corporateReason: "",
      health: false,
      healthDocument: "",
      carpool: false,
      carpoolers: [],
      unity: "",
      registration: "",
      acceptedPolicies: true,
      acceptedDataPolicies: true,
      acceptedDataAccuracy: true,
      year: "2020-2021",
    },
    types: ["Apprenti", "Assistant étudiant", "Collaborateur", "Étudiant"],
    studyTypes: ["Plein temps", "En emploi / Temps partiel"],
    searchAddresses: null,
    addresses: [],
    searchCarpoolers: null,
    carpoolers: [],
    loading: false,
    loadingAddresses: false,
    submitting: false,
    valid: false,
    uploading: false,
  }),
  methods: {
    async handleUpload(file) {
      if (file) {
        this.uploading = true;
        try {
          const formData = new FormData();
          formData.append("file", file);
          const { data } = await axios({
            method: "post",
            url: `${process.env.VUE_APP_API_URI}/uploads`,
            data: formData,
            headers: {
              "content-Type": "multipart/form-data",
              "x-api-key": process.env.VUE_APP_API_KEY,
            },
          });
          this.park.healthDocument = data.filename;
          this.uploading = false;
        } catch (e) {
          this.uploading = false;
          console.log(e);
        }
      }
    },
    removeDocument() {
      this.park.healthDocument = "";
    },
    async submitForm() {
      try {
        this.submitting = true;
        await axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URI}/requests`,
          headers: {
            "x-api-key": process.env.VUE_APP_API_KEY,
          },
          data: {
            ...this.park,
            idisa: this.park.idisa ? this.park.idisa : "no-idisa",
          },
        });
        this.submitting = false;
        this.park = {
          idisa: "no-idisa",
          firstname: "",
          lastname: "",
          email: "",
          type: "",
          studyType: "",
          unityType: "departments",
          address: {},
          children: false,
          childrenReason: "",
          corporate: false,
          corporateReason: "",
          health: false,
          healthDocument: "",
          carpool: false,
          carpoolers: [],
          unity: "",
          registration: "",
          acceptedPolicies: true,
          acceptedDataPolicies: true,
          acceptedDataAccuracy: true,
          year: "2020-2021",
        };
        this.addressType = "local";
        this.acceptedPolicies = false;
        this.updateRequests();
        this.closeFormDialog();
        this.openSnackbar({
          visible: true,
          color: "success",
          text: "Demande ajoutée",
        });
      } catch (e) {
        console.log(e);
        this.submitting = false;
        this.openSnackbar({
          visible: true,
          color: "error",
          text: "Erreur d'ajout de la demande",
        });
      }
    },
    async queryAddresses(v) {
      this.loadingAddresses = true;

      try {
        const { data: mapboxData } = await axios({
          method: "get",
          url: process.env.VUE_APP_MAPBOX_URI,
          params: {
            q: v,
            access_token: process.env.VUE_APP_MAPBOX_TOKEN,
            language: "fr",
            country: "CH,FR,DE,IT",
            types: "address,street",
            proximity: "46.779089,6.659356",
          },
        });

        this.addresses = mapboxData.features.map((r) => ({
          text: r.properties.full_address,
          value: {
            label: r.properties.full_address,
            lat: r.geometry.coordinates[1],
            lon: r.geometry.coordinates[0],
          },
        }));
      } catch (error) {
        console.error("Error fetching addresses:", error);
        this.addresses = [];
      } finally {
        this.loadingAddresses = false;
      }
    },
    customFilter(item, queryText) {
      const normalizedQuery = this.normalizeText(queryText);
      const normalizedAddress = this.normalizeText(item.text);

      // Split query into parts (e.g., "rue du test city" -> ["rue", "du", "test", "city"])
      const queryParts = normalizedQuery.split(" ");

      // Check if all parts of the query exist in the address
      return queryParts.every((part) => normalizedAddress.includes(part));
    },

    normalizeText(text) {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
        .replace(/[^a-z0-9\s]/g, " ") // Replace special chars with spaces
        .replace(/\s+/g, " ") // Replace multiple spaces with single space
        .trim();
    },
    async queryPicker(v, key) {
      this.loading = true;
      const { data: contacts } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_PEOPLEPICKER_URI}/search?s=${v}`,
        headers: {
          "x-api-key": process.env.VUE_APP_PEOPLEPICKER_KEY,
        },
      });
      contacts.map((c) => {
        if (c.email !== this.park.email) {
          this[key].push({
            text: `${c.firstname} ${c.lastname}`,
            value: {
              firstname: c.firstname,
              lastname: c.lastname,
              email: c.email,
              address: "",
            },
          });
        }
      });
      this[key] = _.uniqBy(this[key], "value.email");
      this.loading = false;
    },
    clearSearchCarpoolers() {
      this.searchCarpoolers = null;
    },
    remove(item) {
      const index = this.park.carpoolers.indexOf(item.value);
      if (index >= 0) this.park.carpoolers.splice(index, 1);
    },
  },
  watch: {
    formDialog: function (dialog) {
      if (!dialog) {
        this.requester = {};
        this.park = {
          idisa: "no-idisa",
          firstname: "",
          lastname: "",
          email: "",
          type: "",
          studyType: "",
          unityType: "departments",
          address: {},
          children: false,
          childrenReason: "",
          corporate: false,
          corporateReason: "",
          health: false,
          healthDocument: "",
          carpool: false,
          carpoolers: [],
          unity: "",
          registration: "",
          acceptedPolicies: true,
          acceptedDataPolicies: true,
          acceptedDataAccuracy: true,
          year: "2020-2021",
        };
      }
    },
    searchAddresses: _.debounce(function (val) {
      val && val !== this.park.address && this.queryAddresses(val);
    }, 500),
    searchCarpoolers: _.debounce(function (val) {
      val &&
        val !== this.park.carpoolers &&
        this.queryPicker(val, "carpoolers");
    }, 300),
    addressType: function () {
      this.park.address = {};
    },
    "park.type": function () {
      this.park.studyType = "";
      this.park.unityType = "departments";
    },
    "park.unityType": function () {
      this.park.unity = "";
    },
    "park.address.label": function () {
      if (!this.park.address.label) {
        this.park.address = {};
      }
    },
    requester: async function () {
      if (this.requester) {
        this.park.email = this.requester.email;
        this.park.firstname = this.requester.firstname;
        this.park.lastname = this.requester.lastname;
        const { data } = await axios({
          method: "get",
          url: `${process.env.VUE_APP_PEOPLEPICKER_URI}/fullname?email=${this.park.email}`,
          headers: {
            "x-api-key": process.env.VUE_APP_PEOPLEPICKER_KEY,
          },
        });
        this.park.idisa = data.idisa || "no-idisa";
      } else {
        this.park.email = "";
        this.park.firstname = "";
        this.park.lastname = "";
        this.park.idisa = "no-idisa";
      }
    },
  },
  computed: {
    requiredFields: function () {
      return (
        !!this.park.firstname &&
        !!this.park.lastname &&
        !!this.park.email &&
        this.park.type &&
        this.park.unity &&
        this.park.address.label &&
        this.park.carpoolers.length <= 4 &&
        this.park.registration &&
        (this.park.children ? !!this.park.childrenReason : true) &&
        (this.park.corporate ? !!this.park.corporateReason : true) &&
        (this.park.health ? this.park.healthDocument !== "" : true) &&
        (this.park.carpool ? this.park.carpoolers.length > 0 : true)
      );
    },
  },
};
</script>